console.log("environment: ", process.env.NODE_ENV)
if(process.env.NODE_ENV === "production") {
    //window.console.log = () => null
}
